import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { BillApi } from 'api';

export const findOneBill = createAsyncThunk(
  'bill/findOneDebt',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await BillApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkCanUpdateBill = createAsyncThunk(
  'bill/checkCanUpdateBill',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await BillApi.checkCanUpdate(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkCanRejectBill = createAsyncThunk(
  'bill/checkCanRejectBill',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await BillApi.checkCanReject(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkCanReturnBill = createAsyncThunk(
  'bill/checkCanReturnBill',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await BillApi.checkCanReturn(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const exportCustomerBills = createAsyncThunk(
  'bill/exportCustomerBills',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.exportCustomerBills(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const exportSupplierBills = createAsyncThunk(
  'bill/exportSupplierBills',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.exportSupplierBills(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneDebt = createAsyncThunk(
  'bill/findOneDebt',
  async (debtID: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findOneDebt(debtID);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findBillToCollectDebt = createAsyncThunk(
  'bill/findBillToCollectDebt',
  async (billID: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findOneToCollectDebt(billID);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findBillsToCollectCollaboratorDebt = createAsyncThunk(
  'bill/findBillsToCollectCollaboratorDebt',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findCollaboratorDebt(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findBillsToCollectCustomerDebt = createAsyncThunk(
  'bill/findBillsToCollectCustomerDebt',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findCustomerDebt(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDebt = createAsyncThunk(
  'bill/findDebt',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findDebt(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCustomerBills = createAsyncThunk(
  'bill/findCustomerBills',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findCustomerBills(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findSupplierBills = createAsyncThunk(
  'bill/findSupplierBills',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findSupplierBills(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findReturnBills = createAsyncThunk(
  'bill/findReturnBills',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findReturnBills(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCollaboratorBills = createAsyncThunk(
  'bill/findCollaboratorBills',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findCollaboratorBills(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDebtGroupByCollaborator = createAsyncThunk(
  'bill/findDebtGroupByCollaborator',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findDebtGroupByCollaborator(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCollaboratorDebtGroupByCustomer = createAsyncThunk(
  'bill/findCollaboratorDebtGroupByCustomer',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findCollaboratorDebtGroupByCustomer(
        option
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCollaboratorDebtGroupByCustomerToCollectDebt =
  createAsyncThunk(
    'bill/findCollaboratorDebtGroupByCustomerToCollectDebt',
    async (option: any, { rejectWithValue }) => {
      try {
        const response =
          await BillApi.findCollaboratorDebtGroupByCustomerToCollectDebt(
            option
          );

        return response;
      } catch (error: any) {
        if (!error.response) {
          throw error;
        }

        return rejectWithValue(error.response.data);
      }
    }
  );

export const findCollaboratorDebtGroupBySupplier = createAsyncThunk(
  'bill/findCollaboratorDebtGroupBySupplier',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findCollaboratorDebtGroupBySupplier(
        option
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDebtGroupByCustomer = createAsyncThunk(
  'bill/findDebtGroupByCustomer',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findDebtGroupByCustomer(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDebtGroupBySupplier = createAsyncThunk(
  'bill/findDebtGroupBySupplier',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillApi.findDebtGroupBySupplier(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const rejectBill = createAsyncThunk(
  'bill/rejectBill',
  async (params: { id: string; body: any }, { rejectWithValue }) => {
    const { id, body } = params;

    try {
      const response = await BillApi.rejectBill(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteBill = createAsyncThunk(
  'bill/deleteBill',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await BillApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  reloadFlag: boolean;
  selectedBillCodeForDebt: string[];
}

const initialState: IState = {
  list: [],
  reloadFlag: false,
  // Danh sách mã hóa đơn cho thu nợ
  selectedBillCodeForDebt: [],
};

const billSlice = createSlice({
  name: 'bill',
  initialState,
  reducers: {
    reloadBill(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    setBillCodeForDebt(state, action) {
      state.selectedBillCodeForDebt = action.payload;
    },
  },
});

const { actions, reducer: billReducer } = billSlice;

export const { reloadBill, setBillCodeForDebt } = actions;

export default billReducer;
